import socials from "./socials";

export default socials;
